<template>
  <CDataTable
    :hover="hover"
    :striped="striped"
    :border="border"
    :small="small"
    :fixed="fixed"
    :items="items"
    :fields="fields"
    :items-per-page="20"
    :loading="isLoading"
    :enableAddButton="enableAddButton"
    :dark="dark"
    pagination
    :sorter="{ external: false, resetable: false }"
    :tableFilter="{ label: '', placeholder: 'Searching ...' }"
    :noItemsView="{
      noResults: 'no filtering results available',
      noItems: 'no items available',
    }"
  >
    <template #price="{ item }">
      <td v-if="item.price == null">{{ formatPrice(item.price) }}</td>
      <td v-else>Rp. {{ formatPrice(item.price) }}</td>
    </template>

    <template #total="{ item }">
      <td>Rp. {{ formatPrice(item.total) }}</td>
    </template>

    <template #product_image="{ item }">
      <td>
        {{ item.url }}
        <i v-if="item.flag === '1'" class="fa fa-search" @click="previewImage(item)" />
      </td>
    </template>

      <template #document="{ item }">
      <td>
        {{ item.document }}
        <i class="fa fa-search" @click="previewImage(item)" />
      </td>
    </template>

    <template #total_order="{ item }">
      <td>Rp. {{ formatPrice(item.total_order) }}</td>
    </template>

    <template #max_price="{ item }">
      <td>Rp. {{ item.max_price === null ? "-" : formatPrice(item.max_price) }}</td>
    </template>

    <template #order_number_complaint="{ item }">
      <td>
        {{ item.order_number }}<br /><small>Rp. {{ formatPrice(item.total) }}</small>
      </td>
    </template>

    <template #points="{ item }">
      <td>{{ formatPrice(item.points) }}</td>
    </template>

    <template #referal="{ item }">
      <td>{{ formatPrice(item.referal) }}</td>
    </template>

    <template #percentage="{ item }">
      <td>{{ formatPercentage(item.percentage) }}</td>
    </template>

    <template #start_date="{ item }">
      <td>{{ formatDateHumanRead(item.start_date) }}</td>
    </template>

    <template #end_date="{ item }">
      <td>{{ formatDateHumanRead(item.end_date) }}</td>
    </template>

    <template #date_inserted="{ item }">
      <td>{{ dateTimeFormat(item.date_inserted) }}</td>
    </template>

    <template #date_accepted_time="{ item }">
      <td>{{ dateTimeFormat(item.date_accepted_time) }}</td>
    </template>

    <template #response_time="{ item }">
      <td>{{ dateTimeFormat(item.response_time) }}</td>
    </template>

    <template #date_order="{ item }">
      <td>{{ dateTimeFormat(item.date_order) }}</td>
    </template>

    <template #messages="{ item }">
      <td v-html="item.messages"></td>
    </template>

    <template #description="{ item }">
      <td v-html="item.description"></td>
    </template>

    <template #freezer_information="{ item }">
      <td>
        {{ item.freezer_name }} <small>({{ item.freezer_code }})</small><br />
        <small>{{ item.brand }} - {{ item.freezer_owner_name }}</small
        ><br />
        <small>{{ item.sku }}</small
        ><br />
        <small
          >Capacity: {{ item.capacity }}, Weight: {{ item.weight }}, Voltage:
          {{ item.weight }}, Dimention: {{ item.dimention }}</small
        ><br />
      </td>
    </template>

    <template #action="{ item }">
      <td class="text-center width-50">
        <CButton
          v-if="!redirectDetail && editButton && !redirectDetail2"
          color="success"
          title="Edit"
          size="sm"
          class="text-center"
          @click="editForm(item)"
        >
          <i class="fa fa-edit" />
        </CButton> 
        <CButton
          v-else-if="redirectDetail && editButton"
          color="success"
          title="Detail"
          size="sm"
          @click="goToDetail(item)"
        >
          <i class="fa fa-edit" />
        </CButton> 
        <CButton
          v-else-if="redirectDetail2 && editButton"
          color="success"
          title="Detail"
          size="sm"
          @click="goToDetail2(item)"
        >
          <i class="fa fa-edit" />
        </CButton> 
        &nbsp;<CButton
          v-if="removeButton"
          color="danger"
          title="Remove"
          size="sm"
          @click="removeData(item)"
        >
          <i class="fa fa-remove" />
        </CButton>
      </td>
    </template>
  </CDataTable>
</template>

<script>
import * as moment from "moment";
import Loading from "./Loading.vue";

export default {
  name: "TableOnly",
  components: { Loading },
  props: {
    items: {
      type: [Array, Object],
      default: () => [],
    },
    fields: {
      type: [Array, Object],
      default: () => [],
    },
    title: {
      type: String,
      default: "Table",
    },
    hover: {
      type: Boolean,
      default() {
        return true;
      },
    },
    striped: {
      type: Boolean,
      default() {
        return true;
      },
    },
    border: {
      type: Boolean,
      default() {
        return true;
      },
    },
    small: {
      type: Boolean,
      default() {
        return true;
      },
    },
    fixed: {
      type: Boolean,
      default() {
        return true;
      },
    },
    dark: {
      type: Boolean,
      default() {
        return false;
      },
    },
    redirectDetail: {
      type: Boolean,
      default() {
        return false;
      },
    },
    redirectDetail2: {
      type: Boolean,
      default() {
        return false;
      },
    },
    editButton: {
      type: Boolean,
      default() {
        return false;
      },
    },
    removeButton: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isLoading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    enableAddButton: {
      type: Boolean,
      default() {
        return true;
      },
    },
    customVariableId: {
      type: String,
      default: "id",
    },
  },
  methods: {
    addForm: function () {
      this.$emit("addForm");
    },
    editForm: function (row) {
      this.$emit("editForm", row);
      //this.$emit("isEdit", true);
      this.$root.$emit("bv::show::modal", this.idModals);
    },
    removeData: function (row) {
      this.$emit("removeData", row);
    },
    dateTimeFormat: function (date) {
      if (date) {
        return moment(date).format("DD MMM YYYY HH:mm:ss");
      }
    },
    formatDateHumanRead: function (date) {
      if (date) {
        return moment(date).format("DD MMMM YYYY");
      }
    },
    formatPrice(value) {
      if (value === null || value == null || value == "" || value === "") {
        return "";
      } else {
        let val = (value / 1).toFixed(0).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    formatPercentage(value) {
      if (value === null || value == null || value == "" || value === "") {
        return "";
      } else {
        let val = value + "%";
        return val;
      }
    },
    goToDetail: function (row) {
      let path = this.$route.path.split("/");
      this.$router.push({
        path: path.hasOwnProperty("2")
          ? path[2] + "/detail/" + row[this.customVariableId]
          : "detail/" + row[this.customVariableId],
      });
    },
    goToDetail2: function (row) {
      let path = this.$route.path.split("/");
      this.$router.push({
        path: path.hasOwnProperty("2")
          ? path[3] + "/detail/" + row[this.customVariableId]
          : "detail/" + row[this.customVariableId],
      });
    },
    previewImage: function (img) {
      this.$emit("previewImage", img);
    },
  },
};
</script>

<style></style>
